import React from 'react'
import { connect } from 'react-redux'
import { string, func, bool } from 'prop-types'
import MdCloudDownload from 'react-icons/lib/md/cloud-download'
import { toggleDownloads } from '../../../../../store/Actions/UiActions'
import { P, Option } from '../styles/option'

const DownloadButton = ({ theme, toggleDownloads, showDownloads, online }) => (
  <Option
    onClick={() => online && toggleDownloads(!showDownloads)}
    title="Download results in Geojson or CSV format."
  >
    <MdCloudDownload color={theme} />
    <P theme={theme}>Downloads</P>
  </Option>
)

DownloadButton.propTypes = {
  theme: string.isRequired,
  toggleDownloads: func.isRequired,
  showDownloads: bool.isRequired,
  online: bool.isRequired,
}

const mapStateToProps = ({ spi, ui }) => ({
  theme: spi.theme,
  showDownloads: ui.showDownloads,
  online: spi.online,
})

const mapDispatchToProps = dispatch => ({
  toggleDownloads: value => dispatch(toggleDownloads(value)),
})

export default connect(mapStateToProps, mapDispatchToProps)(DownloadButton)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/OptionsButtons/DownloadButton/index.jsx